module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARFJREFUeNqE0r9LQlEYxvFb3ArEJcilRPB/CHFqcA1zaIj8I9pqcRDMQUF00j1zcEooaIlaopz7MTTW4CgRQoMtft94DhzkWi98ON4fj+ec956lVqcbqDZwjALS+MQDGhgGXi1r3MYLTvCDga53FSz5oVAzXGMVe7jynm+hhyo+9Pt3JltSAsW5gNVIf/SOOlZcyPbwpNmiaoI2NpFxIdv0W/B3PWtMupB1af2fUELjtwtZd3a06UV1iCkeXaiJNZwjHhE4UusvMHYtt5nKqKghHbzqUxwgr7B1MYe7UDdO1daaTkDg7cFWsI+YPkk+9F6wh31kkcKXjo8t6QyXCnbDufXbEbqP2NetlmkH9WYmwAAVnTiOo+/ZXAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/react/components/GoalsSearch/search.png
// module id = 661
// module chunks = 5